import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import BunkeyApi from '../../api/BunkeyAPI'
import { getAssetType, ENDPOINT } from '../../utils'
import { Form, Button, Icon, Upload, Tooltip } from 'antd'
import { sendNotification } from '../../utils/index'
import { putCompanyLogo } from '../../actions/ClientAction'
import axios from 'axios'

export class ChangeLogo extends Component {
  constructor(props) {
    super(props)

    this.state = {
      fileList: null,
      previewImage: null,
      futureFileURL: null,
      url: null,
      disableSubmitButton: true,
      showSizeLimitTxt: null
    }
  }

  handleUrlSignaturePreview = (value) => {
    const { userId } = this.props

    // 2097152bytes equivalen a 2MB
    if (value.size < 2097152) {
      let list = [value]
      this.setState({
        showSizeLimitTxt: false,
        disableSubmitButton: false,
        fileList: list
      })

      BunkeyApi({
        url: 'url-signature',
        method: 'POST',
        data: {
          clientId: userId,
          mimeType: value.type,
          extention: getAssetType(value.type)
        }
      }).then(resp => {
        this.setState({
          previewImage: {
            file: value,
          },
          futureFileURL: resp.data.futureFileURL,
          url: resp.data.url,
        })
      }).catch(err => {
        this.setState({
          previewImage: null
        })
      })
      return false
    } else {
      this.setState({
        showSizeLimitTxt: true,
        disableSubmitButton: true,
        fileList: []
      })
    }
    return false
  }


  handleSubmit = () => {
    const { previewImage, futureFileURL, url } = this.state
    const { workclient, intl } = this.props

    if (previewImage !== null) {
      let promises = []
      promises.push(new Promise(() => {
        const client = axios.create({
          baseURL: ENDPOINT
        })
        client.put(url,
          previewImage.file,
          {
            headers: {
              'Content-Type': previewImage.file.type,
              'Content-Disposition': 'attachment'
            }
          })
          .then(resp => {
            this.props.putCompanyLogo(futureFileURL, workclient)
          })
          .catch(err => {
            sendNotification('error', intl, intl.formatMessage({ id: 'try_again' }))
            this.setState({
              fileList: [],
            })
          })
      }))
    } else {
      sendNotification('error', intl, intl.formatMessage({ id: 'try_again' }))
      this.setState({
        disableSubmitButton: true,
        fileList: []
      })
    }
  }

  handleOnRemovePreview = () => {
    this.setState({
      disableSubmitButton: true,
      showSizeLimitTxt: false,
      previewImage: null,
      fileList: []
    })
  }

  handleCancel = () => {
    this.handleOnRemovePreview()
    this.props.handleHideLogo()
  }


  render() {
    const { newColor, isFetching, intl } = this.props
    const { showSizeLimitTxt, fileList, disableSubmitButton } = this.state
    return (
      <React.Fragment>
        <Form.Item className='config-title' >
          <span> {intl.formatMessage({ id: "select_new_logo" })} </span>
          <Tooltip title={intl.formatMessage({ id: "tooltip_image" })} >
            <Icon type="info-circle" theme="outlined" />
          </Tooltip>
        </Form.Item>
        {showSizeLimitTxt && <Form.Item className='config-warning' >
          <span> {intl.formatMessage({ id: "image_than_equal" })}</span>
        </Form.Item>}
        <Form.Item>
          <Upload
            beforeUpload={this.handleUrlSignaturePreview}
            fileList={fileList}
            onRemove={this.handleOnRemovePreview}
            accept='.png, .jpg, .jpeg, .gif'
            listType='picture'
            style={{
              marginBottom: 10
            }}
            >
            <Button
              style={{ marginRight: '5px', color: newColor, borderColor: newColor }}>
              <Icon type="upload" /> {intl.formatMessage({ id: "upload_logo" })}
            </Button>
          </Upload>
          {disableSubmitButton && <Button
            loading={isFetching}
            type="primary"
            disabled={disableSubmitButton}
            onClick={this.handleSubmit}> {intl.formatMessage({ id: "change" })}</Button>}
          {!disableSubmitButton && <Button
            loading={isFetching}
            type="primary"
            style={{ color: '#fff', backgroundColor: newColor, borderColor: newColor }}
            onClick={this.handleSubmit}> {intl.formatMessage({ id: "change" })}</Button>}
          <Button
            type='default'
            style={{ color: newColor, borderColor: newColor, marginLeft: '10px' }}
            onClick={this.handleCancel}>
            {intl.formatMessage({ id: "cancel_button" })} <Icon type="close" /></Button>
        </Form.Item>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
    userId: state.authUser.user._id,
    workclient: state.client.workclient,
    isFetching: state.client.isFetching
  }
}

const mapDispatchToProps = {
  putCompanyLogo
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(ChangeLogo)))